module.exports = __webpack_public_path__ + "static/media/product_icon_small_white.93b2eb58.svg";